module.exports = __webpack_public_path__ + "img/tpc-web-3.77c7dc37.webp";